<svelte:options accessors/>
<script>
    import { createEventDispatcher } from 'svelte';
    import {cssVariables} from '../utils/CSSVariables';
    import Layout from '../controllers/Layout';
    import { get } from "svelte/store";
    import {currentTable} from "../stores/tablesStore";
    
    export let cardValue;
    export let cardNo = 0;
    export let seat = 0;
    export let rabbit = false;
    export let hidden = true;
    let folded = false;
    let revealed = false;

    let rankColor = "black";
    let xOffset;
    let yOffset;
    let cardBrightness = 100;
    let borderColor = "black";
    let borderWidth = 1;
    const dispatcher = createEventDispatcher();

    export function setCardValue(value)
    {
        cardValue = value != null && String(value).length > 0 ? String(value) : null;
        cardBrightness = 100;
        setHidden(false);
        highlight(false);
        setFolded(false);
        revealed = false;
    }

    export function getCardValue()
    {
        return cardValue;
    }

    export function setHidden(value)
    {
        hidden = value;
    }

    export function setFolded(value = true)
    {
        folded = value;

        if (folded)
            cardBrightness = 60;
        else
            cardBrightness = 100;
    }

    export function setRevealed(value)
    {
        revealed = value;

        dispatcher('reveal', {cardIndex: cardNo, revealed: revealed});  //dispatch reveal event and pass the cardNo
    }

    export function scheduledReveal()
    {
        if (cardValue)
            revealed = true;
    }

    export function highlight(value)
    {
        if (value)
        {
            borderColor = "yellow";
            borderWidth = 3;
        }
        else
        {
            borderColor = "black";
            borderWidth = 1;
        }
    }

    export function compareTo(c)
	{
		if (this.getRank() < c.getRank())
			return -1;
		else if (this.getRank() == c.getRank())
			return 0;
		else
			return 1;
	}

    export function getRankStr(value = null)
    {
        return value ? value.charAt(0) : cardValue.charAt(0);
    }

    export function getRank(value = null)
    {
        let rankStr = getRankStr(value);
        switch (rankStr)
		{
			case "A": return 14;
			case "K": return 13;
			case "Q": return 12;
			case "J": return 11;
			case "T": return 10;
			default: return parseInt(rankStr);
		}
    }

    export function getColor(value = null)
    {
        return value ? value.charAt(1) : cardValue.charAt(1);
    }

    $: {
        if (cardValue)
        {
            const color = getColor(cardValue);
            rankColor = (color == "H" || color == "D") ? "red" : "black";
            borderColor = "black";
        }

        borderWidth = 1;
        
        let tableType = get(currentTable).table_type;

        if (rabbit)
        {
            xOffset = Layout[tableType]["rabbitCards"][0];
            yOffset = Layout[tableType]["rabbitCards"][1];

            xOffset += cardNo * 35;
        }
        else if (seat > 0)
        {
            xOffset = Layout[tableType]["seat" + seat].holeCardsOffsets[0];
            yOffset = Layout[tableType]["seat" + seat].holeCardsOffsets[1];

            xOffset += cardNo * 35;
        }
        else
        {
            xOffset = Layout[tableType]["communityCards"][0];
            yOffset = Layout[tableType]["communityCards"][1];

            xOffset += cardNo * 35;
        }

    }

</script>
{#if hidden != "true" && hidden != true}
    {#if cardValue}
    <div class="vbox pokerCard center" use:cssVariables={{xOffset, yOffset, cardBrightness, borderColor, borderWidth}} on:click={() => {setRevealed(!revealed);}}>
        {#if revealed}
            <span class="reveal">reveal</span>
        {/if}
        <div class="hbox center">
            <span class="rank" use:cssVariables={{rankColor}}>{getRankStr(cardValue)}</span>
            <img class="color" src={"/assets/" + getColor(cardValue) + ".png"}>
        </div>
    </div>
    {:else}
        <div class="hbox pokerCard"  use:cssVariables={{xOffset, yOffset, cardBrightness, borderColor, borderWidth}} style="background-color: brown;">
        </div>
    {/if}
{/if}


<style>
    .pokerCard {
        width: 35px;
        height: 45px;
        position: absolute; 
        margin: 0px;
        padding: 0px;
        filter: brightness(calc(var(--cardBrightness) * 1%));
        left:  calc(var(--xOffset) * 1px);
        top:  calc(var(--yOffset) * 1px);
        text-align: center;
        background-color: white;
        border: calc(var(--borderWidth) * 1px);
        border-style: solid;
        border-color: var(--borderColor);
    }

    .rank {
        color: var(--rankColor);
        font-weight: bold;
        padding: 2px;
    }

    .color {
        width: 13px;
        height: 16px;
        margin-top: 3px;
    }

    .reveal {
        color: red;
        font-size: smaller;
        position: absolute;
        margin-top: -33px;
        margin-left: 2px;
    }

</style>